<div class="page-title animatedBackground">
    <div class="container">
        <h3>Privacy Policy</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Privacy Policy</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details">
                   
                    <div class="blog-details-content">
                    
                     <h4> PERSONAL INFORMATION </h4>
                        <br>
                       <h5> Collection & use of your personal information </h5>
                        
                   <p>     As a part of our service, we gather information from the users of our website, our clients, and the talent that apply to join our company. We collect and use your personal information in order to run our website(s) and provide you with the services you’ve requested. We never sell or rent our client lists to anybody. OSIT may share your information with trusted parties to assist with statistical analysis, send you email newsletters, provide customer service, etc. 
                        We may keep track of which pages our users visit in order to evaluate which OSIT services are the most popular. Customers whose activity suggests that they are interested in a certain subject area are sent tailored content and advertising on OSIT. We will only disclose your personal information if required to do so by law or in good faith. 
                    </p>
                    <p>&nbsp;<br></p>
                     <h4>   COOKIES </h4>
                     <br>
                    <h5>    Cookies Policy </h5>
                        
                  <p>      Cookies are small data files that may or may not contain an anonymous unique identification. A website sends cookies to your browser, which are then transferred to your device. Cookies are used to collect data so that we can enhance our services for you. You may set your browser to reject all cookies or to notify you when one is received. Many browsers have a help feature that will tell you how to accept cookies, disable cookies, or be notified when you receive a new cookie. You may not be able to access some aspects of our Service if you do not allow cookies, therefore we recommend that you leave them set on. 
                </p>
                <p>&nbsp;<br></p>
                <h4>  RESOURCES </h4>
                <br>
                <h5>    Newsletters & Blogs </h5>
                        
                <p>  We provide opportunities to sign-up for our email newsletters sent out periodically. You can subscribe to it by sharing your email address and confirming by clicking on the confirmation link sent out to you. In this process, we collect your email address, IP address, and time of subscription. We discreetly use this information for the distribution of email newsletters only. You can cancel the subscription at any time with the help of unsubscribe instructions followed in each newsletter. Once you unsubscribe, all the personal information is deleted permanently from our system. We periodically post blogs on our website that are accessed publicly. You can freely comment on your reviews, suggestions, or start discussions in the comment section of the blogs. We want to inform you that any information that is shared by you in the comments can be read, shared, or collected by anyone who reads them. 
                        </p>
                        <p>&nbsp;<br></p>
                        <h4>    ANALYTICS </h4>
                        <br>
                        <h5>     Google Analytics </h5>
                        
                        <p>   At OSIT, we use Google Analytics in order to monitor and analyze how users interact with our website. This helps us in improving the quality of services, content, and communication that we provide to our users. We would like to assure you that no personal data is stored in this process and you can verify it with the Google Analytics policy as well. 
                        </p>
                        <p>&nbsp;<br></p>
                        <h4>  CONSENT </h4>
                        <br>
                        <h5>       Acceptance of Policy </h5>
                        
                        <p>   You agree to our privacy policy by accessing this website or using services provided by this website. Please do not use our website or the services provided by this website if you do not agree with any of the terms. We also reserve the right, at our discretion, to amend, modify, add, or remove elements of this policy by simply posting such changes, updates, or modifications on the website. Continued use of our site after the policy terms have been changed indicates your acceptance of these terms. 
                        </p>
                        <p>&nbsp;<br></p>
                        <h4>  UPDATE </h4>
                        
                        <p>This Privacy Policy was last updated in Auguest 2022. </p>
                    </div>
                </div>
            </div>

        
        </div>
    </div>
</section>

